$(() => {
  $(".auto-submit").on("change", function () {
    $(this).closest("form").submit();
  });

  $(document).on("change", ".select-all", function () {
    $(this).closest("form").find(".id-identifier input[type=checkbox]").prop("checked", this.checked);
  });

  //TODO: needs to refactor ---------------------------
  let elemFailed = $("#failed");

  if (elemFailed) {
    $(elemFailed).addClass("active");
    $(".failed-body").addClass("active show");
  }

  if (!elemFailed.is(":visible")) {
    $("#success").addClass("active");
    $(".success-body").addClass("active show");
  }

  $(".input-range").on("input", function () {
    const min = parseInt(this.min);
    const max = parseInt(this.max);

    if (parseInt(this.value) > max) this.value = max;
    if (parseInt(this.value) < min) this.value = min;
  });

  $(".date-picker").datepicker({
    format: "dd-mm-yyyy",
    weekStart: 1,
    autoclose: true,
    todayHighlight: true,
    templates: {
      leftArrow: '<i class="bi-chevron-left" aria-hidden="true"></i>',
      rightArrow: '<i class="bi-chevron-right" aria-hidden="true"></i>',
    },
  });
});

class DatePicker {
  defaults = {
    format: "dd-mm-yyyy",
    weekStart: 1,
    autoclose: true,
    todayHighlight: true,
    templates: {
      leftArrow: '<i class="bi-chevron-left" aria-hidden="true"></i>',
      rightArrow: '<i class="bi-chevron-right" aria-hidden="true"></i>',
    },
  };

  constructor(element, options) {
    $(element).datepicker({ ...this.defaults, ...options });
    element.addEventListener("setDate", (event) => {
      $(element).datepicker("update", event.detail?.date);
    });
  }
}

window.DatePicker = DatePicker;

class SelectTwo {
  static DEFAULTS = {
    placeholder: "- Select -",
    allowClear: true,
    width: "100%",
    theme: "bootstrap4",
  };

  constructor(element, options) {
    const opts = {};
    if (element.dataset.placeholder) opts.placeholder = element.dataset.placeholder;

    $(element).select2({ ...SelectTwo.DEFAULTS, ...opts, ...(options || {}) });
    $(element).on("change.select2", () => element.form?.dispatchEvent(new Event("change", { bubbles: true })));
  }
}

window.SelectTwo = SelectTwo;

class SelectComboBox extends SelectTwo {
  constructor(element, options) {
    super(element, { ...(options || {}), tags: true });
  }
}

window.SelectComboBox = SelectComboBox;
